import { ResponseCode } from '@/common/request/types';
import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_HOMEPAGE } from '@/modules/main/router';
import { avatarService } from '@/services/avatar';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';

export const AvatarGender = [
    { label: 'Female', value: 0, background: 'success' },
    { label: 'Male', value: 1, background: 'info' }
];

export function useAvatarGender() {
    const router = useAppRouter();
    const { executeAction, excuteAndNotify, confirmAndRemove } = useCrudActions();

    const model = reactive({
        gender: null,
        image: null,
        imageStatus: null,
        imageFile: null,
        canDelete: false
    });

    const validations = {
        gender: { required },
        imageFile: { required }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = executeAction({
        canExecute: () => model.gender != null,
        request: () => avatarService.gender.get(model.gender),
        onSuccess: ({ data }) => {
            Object.assign(model, data);
            model.canDelete = true;
            model.imageFile = null;
        },
        onError: ({ code }) => {
            if (code === ResponseCode.NothingFound) {
                model.canDelete = false;
                model.imageFile = null;
            } else router.push({ name: ROUTE_NAME_HOMEPAGE });
        }
    });

    const actions = {
        update: excuteAndNotify({
            validator: v$,
            request: () => avatarService.gender.update(model.gender, model.imageFile),
            onSuccess: fetch
        }),
        remove: confirmAndRemove({
            request: () => avatarService.gender.remove(model.gender),
            onSuccess: fetch
        })
    };

    return { model, v$, fetch, actions, AvatarGender };
}
